module.exports = __webpack_public_path__ + "assets/pictograms/unsubscribe.0b406813ddca9a9197ebfb7688ef3ab0.svg";